var exports = {
  "_": "SubmitTooltip.module__buttonWrapper___ckxZMD",
};

module.exports = exports;
